export enum UserInteractionEventName {
  templateCardClicked = "template_card_clicked",
  templateBookmarkButtonClicked = "template_bookmark_button_clicked",
  templateModalViewed = "template_detail_modal_viewed",
  templateCreateClicked = "template_create_clicked",
  templateLoadingScreenViewed = "template_loading_screen_viewed",
  googleSSOButtonClicked = "google_sso_button_clicked",
  templateShareButtonClicked = "template_share_button_clicked",
  mediaSlideshowItemSelected = "media_slideshow_item_selected",
  mediaSlideshowCarouselArrowClicked = "media_slideshow_carousel_arrow_clicked",
}

export const UserInteractionEvent =
  "web_analytics.tracking.user_interaction.UserInteractionEvent";

// constants for ZapEntryPointEvent and ZapCreationRequestSuccessEvent in
// the service or as query params via webintent
export const ENTRY_POINT_METHOD_QUERY_PARAM = "entry-point-method";
export const ENTRY_POINT_LOCATION_QUERY_PARAM = "entry-point-location";
export const ENTRY_POINT_METHOD = "zap_template";
export const ENTRY_POINT_LOCATION = "templates_home";
